import { createContext } from 'react';
export const SaleListContext = createContext<any>(null);
